import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MobileLayout from "../MobileLayout";
import MobileCompaniesList from "./MobileCompaniesList";
import MobileCompanyDrawer from "./MobileCompanyDrawer";

/**
 * Mobile route for /companies and /companies/:companyID.
 * - Always shows the list.
 * - If :companyID is present, shows a right drawer on top.
 *
 * NOTE: When opened from a background route, App-level modal routing will render
 * only the drawer, not this page.
 */
export default function MobileCompaniesPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { companyID } = useParams();

  const open = Boolean(companyID);

  const handleOpenCompany = (id) => {
    navigate(`/companies/${id}`, {
      state: { backgroundLocation: location },
    });
  };

  const handleCloseDrawer = () => {
    if (location.state?.backgroundLocation) {
      navigate(-1);
      return;
    }
    navigate("/companies");
  };

  return (
    <MobileLayout title="Companies">
      <MobileCompaniesList onOpenCompany={handleOpenCompany} />
      <MobileCompanyDrawer
        open={open}
        companyID={companyID}
        onClose={handleCloseDrawer}
      />
    </MobileLayout>
  );
}


